import { createFileRoute } from '@tanstack/react-router';

import { AuthLayout } from '@/components/layouts/AuthLayout';
import { ClientAuthBrandPanel } from '@/components/layouts/components/ClientAuthBrandPanel';
import { ForgotPasswordSent } from '@/features/auth/components/ForgotPasswordSent';

export const Route = createFileRoute('/client_/forgot-password/sent')({
  component: Page,
  validateSearch: (s: Record<string, unknown>) => ({
    email: typeof s.email === 'string' ? s.email : undefined,
  }),
});

function Page() {
  return (
    <AuthLayout formSide="right" brandPanel={<ClientAuthBrandPanel />}>
      <ForgotPasswordSent variant="client" />
    </AuthLayout>
  );
}
